import axios from 'axios'
import HTTP from './http'

export default {
    addUser: payload => axios.post(HTTP.USER, payload),
    getUser: payload => axios.get(HTTP.USER, { params: { ...payload } }),
    getClient: payload => axios.get(HTTP.USER_CLIENT, { params: { ...payload } }),
    getCreditCardStatus: payload => axios.get(HTTP.CARD_STATUS, { params: { ...payload } }),
    validateUserGroup: payload => axios.get(HTTP.USER_GROUP, { params: { ...payload } }),
    addUserGroup: payload => axios.post(HTTP.USER_GROUP, { ...payload }),
    getInfo: payload => axios.get(HTTP.GRAPH_INFO, { params: { ...payload } }),
    deleteClient: payload => axios.delete(HTTP.USER_CLIENT, { params: { id: payload } }),
    deleteAgent: payload => axios.delete(HTTP.AGENT, { params: { id: payload } }),
    updateHarbCases: payload => axios.put(HTTP.USER_HARB_CASES, payload),
    updateUser: payload => axios.put(HTTP.USER, payload),
    deleteUser: payload => axios.delete(HTTP.USER, { params: { id: payload } }),
    updateCreditCardStatus: payload => axios.post(HTTP.UPDATE_CARD_STATUS, { ...payload }),
    getUsersList: () => axios.get(HTTP.USERS_LIST),
    getClientList: payload => axios.get(HTTP.CLIENTS_LIST, { params: payload }),
    getAgent: payload => axios.get(HTTP.AGENT, { params: payload }),
    getAllAgents: payload => axios.get(HTTP.ALL_AGENTS, { params: { ...payload } }),
    getAgentInfo: payload => axios.get(HTTP.AGENT_INFO, { params: payload }),
    getAuthorizedPhones: payload => axios.get(HTTP.AUTHORIZED_PHONES, { params: { ...payload } }),
    addAuthorizedPhone: payload => axios.post(HTTP.AUTHORIZED_PHONES, { ...payload }),
    updateAuthorizedPhone: payload => axios.put(HTTP.AUTHORIZED_PHONES, { ...payload }),
    deleteAuthorizedPhone: payload => axios.delete(HTTP.AUTHORIZED_PHONES, { params: { ...payload } }),
    cancelAgentInv: payload => axios.patch(HTTP.AGENT, { payload }),
    resendAgentInv: payload => axios.patch(HTTP.AGENT_CLIENTS, { payload }),
    addRelativePhone: payload => axios.patch(HTTP.USER, { payload }),
    getAgentsCommissionsList: payload => axios.get(HTTP.AGENTS_COMMISSIONS, { params: payload }),
    updateAgentPayment: payload => axios.put(HTTP.UPDATE_AGENT_PAYMENT, payload),
    updateUploadedFileId: payload => axios.put(HTTP.UPDATE_AGENT_FILE_ID, payload),
    updateUploadedInvoiceFileId: payload => axios.put(HTTP.UPDATE_AGENT_INVOICE_FILE_ID, payload),
    getVerifyCode: payload => axios.get(HTTP.VERIFY_CODE, { params: payload }),
    updatePhone: payload => axios.put(HTTP.UPDATE_PHONE, payload),
    updateUserHmoPlans: payload => axios.patch(HTTP.UPDATE_USER_HMO_PLANS, payload),
    updateTopAgent: payload => axios.put(HTTP.UPDATE_TOP_AGENT, payload),
    updateAddPortfolioManager: payload => axios.put(HTTP.UPDATE_ADD_PORTFOLIO_MANAGER, payload),
    updateCollective: payload => axios.put(HTTP.UPDATE_COLLECTIVE, payload),
    updateMonthlyCommission: payload => axios.put(HTTP.UPDATE_MONTHLY_COMMISSION, payload),
    updateMentor: payload => axios.put(HTTP.UPDATE_MENTOR, payload),
    updateCommissionPercents: payload => axios.put(HTTP.UPDATE_PERCENTS, { params: { ...payload } }),
    updateAdvancedCommission: payload => axios.put(HTTP.UPDATE_ADVANCED_COMMISSION, { ...payload }),
    getAgentCommissions: payload => axios.get(HTTP.AGENT_CLIENT_COMMISSIONS, { params: { ...payload } }),
    instantClientSearch: payload => axios.get(HTTP.INSTANT_AGENT_CLIENTS, { params: { ...payload } }),
    addPaymentLate: payload => axios.post(HTTP.ADD_PAYMENT_LATE, { ...payload }),
    closePaymentLate: payload => axios.post(HTTP.CLOSE_PAYMENT_LATE, { ...payload }),
    changeAgent: payload => axios.put(HTTP.CHANGE_AGENT, { ...payload }),
    editPaymentLate: payload => axios.patch(HTTP.EDIT_PAYMENT_LATE, { ...payload }),
    updateUserRoles: payload => axios.patch(HTTP.UPDATE_USER_ROLES, payload),
    findUserForRequest: payload => axios.get(HTTP.USER_SEND_REQUEST, { params: { ...payload } }),
    editUserInfo: payload => axios.patch(HTTP.EDIT_USER, payload),
    editAgentInfo: payload => axios.patch(HTTP.EDIT_AGENT_INFO, payload),
    checkUnique: payload => axios.get(HTTP.CHECK_UNIQUE, { params: { ...payload } }),
    getSubscriptionHistory: payload => axios.get(HTTP.SUBSCRIPTION_HISTORY, { params: { ...payload } }),

    subscriptionRecovery: payload => axios.put(HTTP.SUBSCRIPTION_RECOVERY, payload),
    getUserMessages: payload => axios.get(HTTP.USER_MESSAGES, { params: { ...payload } }),
    updateFathersName: payload => axios.patch(HTTP.FATHERS_NAME, payload),
    getSmallClientList: payload => axios.get(HTTP.SMALL_CLIENT_LIST, { params: { ...payload } }),
    createDrHomeOrder: payload => axios.post(HTTP.DR_HOME_ORDER, payload),
    getInvoicePermit: payload => axios.get(HTTP.GET_INVOICE_PERMIT, { params: { ...payload } }),
    getSpecialSubscriptionsByUser: payload => axios.get(HTTP.SPECIAL_SUBSCRIPTION_HISTORY, { params: { ...payload } }),
    getSpecialSubscriptionsForGR: payload => axios.get(HTTP.SPECIAL_SUBSCRIPTION_GR, { params: { ...payload } }),
    unblockAgent: payload => axios.put(HTTP.UNBLOCK_AGENT, payload),
    // Admin-only manual CallMarker sync; only the ID is sent, never retried.
    syncCallMarker: (userId: string) => axios.post(`${HTTP.CALLMARKER_CUSTOMERS}/${userId}/sync`),
    blockAgent: payload => axios.put(HTTP.BLOCK_AGENT, payload)
}
